const e = {
  name: "Email",
  dimensions: { width: 40, height: 32 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 32" style="enable-background:new 0 0 40 32;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M3,0C1.3,0,0,1.3,0,3v26c0,1.7,1.3,3,3,3h34c1.7,0,3-1.3,3-3V3c0-1.7-1.3-3-3-3H3z M2,3.2L16.3,16L2,28.8V3.2
			z M3.6,30l14.2-12.7l2.2,2l2.2-2L36.4,30H3.6z M38,28.8L23.7,16L38,3.2V28.8z M36.4,2L20,16.7l-1.6-1.4L3.6,2H36.4z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Email
};
